// extracted by mini-css-extract-plugin
export default {"title":"NotFound_title__OQ-MU","button":"NotFound_button__tmXsI"};